import { render, staticRenderFns } from "./FullWidthText.vue?vue&type=template&id=011c6c96&"
import script from "./FullWidthText.vue?vue&type=script&lang=js&"
export * from "./FullWidthText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports